import React from "react";
import {formatShortenNumber} from '../utils/format';
import {useQueryStateTopReferer} from "../hook/useQuery";
import {useTranslation} from '../hook/useTranslation'

const TopRefererList = ({
	numberReferrer,
	from,
	to
})=>{

	const i18n = useTranslation("base")

	const list = useQueryStateTopReferer('wpDashboardWidget', {
		numberOfItems: numberReferrer,
		from, to
	})

	if(list.length < 1){
		return <p>No referer</p>;
	}

	return <ul className="ocdb-list">
		{list.map(({referer_domain,hits}, index) => {
			const url = (referer_domain)? "http://"+referer_domain: "#"
			const title = (referer_domain) ? referer_domain : i18n.unknown
			return <li className="ocdb-list-item" key={`post_${title}`}>
				<span className="ocdb-list-item-title">
				<a href={url} target="_blank">{title}</a>
				</span>
				<br />
				<span className="ocdb-list-item-count">{formatShortenNumber(hits)} {i18n.hits}</span>
			</li>
		})}
	</ul>
}

export default TopRefererList